// src/components/modals/EditGroupModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import ChatAvatar from '../ChatAvatar';
import { isValidAvatarFile, getAvatarErrorMessage } from '../../utils/fileHelpers';
import './GroupModal.css';
import {
    ALLOWED_AVATAR_EXTENSIONS,
    ALLOWED_AVATAR_MIME_TYPES,
    MAX_AVATAR_SIZE
} from '../../utils/constants';

const EditGroupModal = ({
    isOpen,
    onClose,
    group,
    showNotification,                       // объект группы { chat_id, title, avatar }
    onSave,                      // ({ name, avatarFile }) => Promise
}) => {
    const [name, setName] = useState('');
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && group) {
            setName(group.title || '');
            setAvatarFile(null);
            setAvatarPreview('');
        }
    }, [isOpen, group]);

    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (!isValidAvatarFile(file)) {
            showNotification(getAvatarErrorMessage(file), 'warning');
            e.target.value = '';   // сбрасываем выбор
            return;
        }
            setAvatarFile(file);
            setAvatarPreview(URL.createObjectURL(file));
        
    };

    const handleSave = async () => {
        if (!name.trim()) {
            alert('Введите название группы');
            return;
        }

        setLoading(true);
        try {
            await onSave({ name: name.trim(), avatarFile });
            onClose();
        } catch (error) {
            console.error('Failed to save group:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Редактировать группу"
            icon="bi bi-pencil"
            size="medium"
            footer={
                <>
                    <button className="btn-cancel" onClick={onClose}>Отмена</button>
                    <button 
                        className="btn-save" 
                        onClick={handleSave}
                        disabled={loading || !name.trim()}
                    >
                        {loading ? 'Сохранение...' : 'Сохранить'}
                    </button>
                </>
            }
        >
            <div className="group-avatar-section">
                {avatarPreview ? (
                    <div className="avatar-preview">
                        <img src={avatarPreview} alt="Avatar" className="avatar-img" />
                    </div>
                ) : (
                    <ChatAvatar
                        chat={{
                            avatar: group?.avatar,
                            title: name || group?.title || 'Группа',
                            chat_id: group?.chat_id?.length || 0,
                        }}
                        className="avatar-preview"
                        imgClassName="avatar-img"
                        placeholderClassName="avatar-placeholder"
                    />
                )}
                <label className="avatar-upload-btn">
                    <i className="bi bi-camera"></i>
                    {group?.avatar ? 'Изменить аватар' : 'Загрузить аватар'}
                    <input
                        type="file"
                        accept={ALLOWED_AVATAR_MIME_TYPES}
                        onChange={handleAvatarChange}
                        hidden
                    />                    
                </label>
                <span>{ALLOWED_AVATAR_EXTENSIONS.join(', ')} (max {MAX_AVATAR_SIZE/1024/1024},0 Мб )</span>
            </div>

            <input
                className="profile-input"
                type="text"
                placeholder="Название группы"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
                maxLength={100}
            />
        </Modal>
    );
};

export default EditGroupModal;